import { useState } from "react";
import { submitFormMutation } from "../../data-service/forms/functions";

export const RecruitmentForm = ({ title, description }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [hospital, setHospital] = useState("");
  const [focus, setFocus] = useState("");
  const [call, setCall] = useState(false);
  const [info, setInfo] = useState(false);
  const [report, setReport] = useState(false);

  const resetFields = () => {
    setName("");
    setEmail("");
    setHospital("");
    setFocus("");
    setCall(false);
    setInfo(false);
    setReport(false);
  };

  function textFieldChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "workEmail":
        setEmail(value);
        break;
      case "hospital":
        setHospital(value);
        break;
      case "focus":
        setFocus(value);
        break;
      case "call":
        setCall(!call);
        break;
      case "info":
        setInfo(!info);
        break;
      case "report":
        setReport(!report);
        break;
      default:
        break;
    }
  }
  return (
    <section className="section-sp2">
      <div
        className="container inner-content"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <h1>Start Recruiting Smarter Today</h1>
        <p>Tell us how we can help you connect with the right HCPs.</p>
        <div
          style={{
            maxWidth: "630px",
            boxShadow: "0px 10px 60px 0px rgba(31, 34, 120, 0.1)",
            paddingTop: "20px",
            paddingInline: "20px",
            borderRadius: "20px",
            background: "#FFFFFF",
          }}
          className=""
        >
          <div className="row">
            <div className="mb-30">
              <form
                className="form-wraper contact-form ajax-form"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const res = await submitFormMutation({
                    senderName: name,
                    email,
                    companyName: hospital,
                    hcpsTargeting: focus,
                    scheduleACall: call,
                    sendInformation: info,
                    sendSampleLeadReport: report,
                    formName: "recruitment-marketing",
                    pageUrl: "recruitment-marketing",
                  });

                  if (res.id) {
                    alert(
                      "Thank you for your interest. We will get back to you shortly."
                    );
                    resetFields();
                  }
                  console.log(name, email, hospital, focus, call, info, report);
                }}
              >
                <div className="ajax-message"></div>
                <div className="row">
                  <div className="form-group ">
                    <input
                      name="name"
                      type="name"
                      required
                      value={name}
                      className="form-control"
                      placeholder="Name"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      name="workEmail"
                      type="text"
                      required
                      value={email}
                      className="form-control"
                      placeholder="Work Email*"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      name="hospital"
                      type="text"
                      value={hospital}
                      className="form-control"
                      placeholder="Hospital/System"
                      onChange={textFieldChange}
                    />
                  </div>

                  <div className="form-group col-md-12">
                    <input
                      name="focus"
                      type="text"
                      value={focus}
                      className="form-control"
                      placeholder="Primary Specialty Focus"
                      onChange={textFieldChange}
                    />
                  </div>
                  <p style={{ fontSize: "18px", fontWeight: "600" }}>
                    What would you like us to do?
                  </p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                      justifyContent: "center",
                      marginBlock: "20px",
                    }}
                  >
                    <div
                      class="form-check"
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        class="form-check-input"
                        style={{
                          width: "30px",
                          height: "30px",
                          borderColor: "#C0D4EB",
                        }}
                        type="checkbox"
                        name="call"
                        id="call"
                        checked={call}
                        onChange={textFieldChange}
                      />
                      <label class="form-check-label" for="call">
                        Schedule a call
                      </label>
                    </div>
                    <br />
                    <div
                      class="form-check"
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        class="form-check-input"
                        style={{
                          width: "30px",
                          height: "30px",
                          borderColor: "#C0D4EB",
                        }}
                        type="checkbox"
                        name="info"
                        id="info"
                        checked={info}
                        onChange={textFieldChange}
                      />
                      <label class="form-check-label" for="info">
                        Send me more information
                      </label>
                    </div>
                    <br />
                    <div
                      class="form-check"
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        class="form-check-input"
                        style={{
                          width: "30px",
                          height: "30px",
                          borderColor: "#C0D4EB",
                        }}
                        type="checkbox"
                        name="report"
                        checked={report}
                        id="report"
                        onChange={textFieldChange}
                      />
                      <label class="form-check-label" for="report">
                        Send me a sample Physician Lead Report
                      </label>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <button
                      name="submit"
                      type="submit"
                      defaultValue="Submit"
                      className="btn w-100 btn-secondary btn-lg"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
